module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Titel","data":"Daten","cancel":"abbrechen","save":"speichern","name":"Name","azure_group":"Entra-Gruppe"},"en":{"title":"Title","data":"Data","cancel":"cancel","save":"save","name":"Name","azure_group":"Entra group"}}')
  delete Component.options._Ctor
}
